import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchItemHistory, } from "../redux/actions";
import {
    userSelector,
    eventItemSelector, itemSelector,
} from "../redux/selectors";
import { toArray } from '../common/util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import Moment from 'react-moment';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, LabelList, Label } from 'recharts';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {scaleTime} from "d3-scale"
import {timeDay} from "d3-time";

class DKPItemDetail extends Component {

    componentDidMount() {
        document.title = "Addiction | DKP | " + this.props.match.params.id.toUpperCase() + " | History"
        this.props.getEventItemHistory(this.props.match.params.id)
    }

    data = []

    getTicks = (data) => {
        if (!data || !data.length ) {return [];}        
        const domain = [new Date(data[0].time), new Date(data[data.length - 1].time)];
        const scale = scaleTime().domain(domain).range([0, 1]);
        const ticks = scale.ticks(timeDay, 1);
        
        return ticks.map(entry => +entry);
    };
    
    getTicksData = (data, ticks) => {
        if (!data || !data.length ) {return [];}
        const dataMap = new Map(data.map((i) => [i.time, i]));
        ticks.forEach(function (item, index, array) {
            if(!dataMap.has(item)) {
                data.push({time: item});
            }
        });
        return data;
    }
    
    dateFormat = (time) => {
        return moment(time).format('MMM D YYYY');
    };

    render() {
        if (toArray(this.props.eventItems.data).filter((event) => this.props.items.data[event.item].slug === this.props.match.params.id).length > 0) {
            let item = this.props.items.data[toArray(this.props.eventItems.data).filter((event) => this.props.items.data[event.item].slug === this.props.match.params.id).shift().item]
            if (item != null) {
                
                this.data = toArray(this.props.eventItems.data).filter((event) => this.props.items.data[event.item].slug === item.slug).map((item) => { return {
                    "Purchaser": this.props.users[item.userDetail].displayName,
                    "DKP": Math.floor(item.dkp),
                    "time": new Date(item.created).getTime()
                }})
                const ticksArr = this.getTicks(this.data);
                const completeData = this.getTicksData(this.data, ticksArr);
                return (
                    <div>
                        <h1>{item.title} History</h1>
                        <div className='panel-adt'>
                            <ResponsiveContainer height={300} width="100%">
                            <LineChart                                 
                                data={completeData}
                                >                                
                                <XAxis 
                                    dataKey="time" 
                                    type="number"
                                    ticks={ticksArr} 
                                    tickCount={ticksArr.length}
                                    tickFormatter={this.dateFormat}
                                    domain={[
                                        this.data[0].time,
                                        this.data[this.data.length -1].time
                                    ]}
                                />
                                <YAxis
                                    dataKey="DKP" 
                                    type="number" 
                                    domain={[
                                        0, 
                                        Math.max(...toArray(this.props.eventItems.data).filter((event) => this.props.items.data[event.item].slug === item.slug).map((item) => {return item.dkp})) +
                                        Math.floor(Math.max(...toArray(this.props.eventItems.data).filter((event) => this.props.items.data[event.item].slug === item.slug).map((item) => {return item.dkp}))*0.1)
                                    ]} 
                                    allowDataOverflow={false}
                                >
                                    <Label 
                                        value="DKP Purchase Price"
                                        offset={0}
                                        position="insideLeft"
                                        angle={-90}
                                        style={{ fill: 'rgba(230, 230, 230, 0.87)' }}
                                    />
                                </YAxis>
                                <Tooltip contentStyle={{backgroundColor: "rgba(0, 0, 0, 0.65)", border: "0"}} labelFormatter={(date) => this.dateFormat(date)} />
                                <Line stroke="none" fill="none" dataKey="Purchaser" />
                                <Line dataKey="DKP" stroke="#82ca9d" fill="#82ca9d" isAnimationActive={false} barSize="10px">
                                    <LabelList 
                                        dataKey="Purchaser"
                                        position="top"
                                        style={{ fill: 'rgba(230, 230, 230, 0.87)' }}
                                    />
                                    <LabelList 
                                        dataKey="DKP"
                                        position="bottom"                                        
                                        style={{ fill: 'rgba(230, 230, 230, 0.87)' }}
                                    />
                                </Line>
                            </LineChart>
                            </ResponsiveContainer>
                        </div>
                        {toArray(this.props.eventItems.data)
                        .sort((a, b) => (new Date(b.created).getTime() - new Date(a.created).getTime()))
                        .filter((event) => this.props.items.data[event.item].slug === item.slug).map((item) => (
                            <div className='panel-adt' key={`${item.id}-item`}>
                                <span><Link to={"/dkp/standings/"+this.props.users[item.user].slug+"/"+item.sectionSlug}><h5>{this.props.users[item.user].displayName}</h5></Link> purchased for <FontAwesomeIcon className="text-primary" icon={faCoins} fixedWidth /> {Math.floor(item.dkp)} DKP <Moment fromNow>{item.created}</Moment></span>
                            </div>
                        ))}
                    </div>
                )
            } else { return null }
        } else { return null }
    }
}

const mapStateToProps = (state) => ({
    users: userSelector(state),
    eventItems: eventItemSelector(state),
    items: itemSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getEventItemHistory: (item) => dispatch(fetchItemHistory(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DKPItemDetail);


// WEBPACK FOOTER //
// ./src/DKP/DKPItemDetail.js